import React from "react";
import { Box, Paper, Button } from "@mui/material";
import "./CustomPicker.css";
import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/en-ca";
import _range from "lodash/range";

const CustomMonthPicker = ({ getSelectedMonth, positionTop, positionLeft }) => {
  dayjs.extend(localeData); // use plugin
  dayjs.locale("en-ca"); // use locale
  const months = dayjs.monthsShort();
  return (
    <Box
      className="monthContainer"
      style={{
        top: "50px",
        left: "-50px",
      }}
    >
      {months.map((month, i) => (
        <Paper key={i} elevation={0} className="monthRange">
          <Button
            id={i}
            className="monthButton"
            value={month}
            onClick={(event) => getSelectedMonth(event)}
          >
            {month}
          </Button>
        </Paper>
      ))}
    </Box>
  );
};

export default CustomMonthPicker;
